export default __webpack_public_path__ + "static/belgacoin-25b30ae48afde78e92ec19aa64c42625.png";